import Vue from 'www/vue_components'
import vuetify from 'www/modules/vuetify-plugin'
import MemoryBoardPage from 'src/components/pages/memorial/MemoryBoardPage/MemoryBoardPage.vue'

const mountElement = document.querySelector('.vue-memory-board-page')

if (mountElement) {
  new Vue({
    el: mountElement,
    vuetify,
    components: {
      MemoryBoardPage,
    },
  })
}
